import { useCallback, useEffect, useState } from 'react';

// inspired from https://usehooks.com/usecopytoclipboard
// addition: copied state / reset
function oldSchoolCopy(text: string) {
  const tempTextArea = document.createElement('textarea');
  tempTextArea.value = text;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  document.execCommand('copy');
  document.body.removeChild(tempTextArea);
}

export function useCopyToClipboardWithReset() {
  const [state, setState] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    function reset() {
      setCopied(false);
    }

    const timeoutId = copied === true ? setTimeout(reset, 1500) : undefined;

    return () => {
      clearTimeout(timeoutId);
    };
  }, [copied]);

  const copyToClipboard = useCallback(
    (value: string) => {
      if (copied && value === state) return;

      const handleCopy = async () => {
        try {
          if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(value);
            setState(value);
            setCopied(true);
          } else {
            throw new Error('writeText not supported');
          }
        } catch {
          oldSchoolCopy(value);
          setState(value);
          setCopied(true);
        }
      };

      handleCopy();
    },
    [state, copied],
  );

  return { copied, state, copyToClipboard };
}
